/**
 * Check if browser supports local storage
 *
 * @param type
 * @returns {boolean}
 */
export const storageAvailable = (type) => {
    try {
        let storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return e instanceof DOMException && (
            e.code === 22 ||
            e.code === 1014 ||
            e.name === 'QuotaExceededError' ||
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED')
    }
};

/**
 * Check validity of Email
 *
 * @param email
 * @returns {boolean}
 */
export const isEmail = (email = null) => {

    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return regex.test(email);

};

/**
 * If token was set more than a month ago, require the user to login again
 *
 * @returns {boolean}
 */
export const canLogin = () => {

    let can = false;

    if (storageAvailable('localStorage')) {

        let token = localStorage.getItem('token');
        let date = localStorage.getItem('token_date');

        if(token && date){

            date = new Date(date);

            let diff = new Date().getMonth() - date.getMonth();

            /**
             * Token was obtained less than a month ago, let them through
             */
            if(diff === 0)
                can = true;
        }

    }

    return can;
};

/**
 * Log user out
 */
export const logOut = () => {

    if (storageAvailable('localStorage')) {

        localStorage.removeItem('token');
        localStorage.removeItem('token_date');
    }
};

export const getStoredData = (key) => {
    if (storageAvailable('localStorage')) {
        return localStorage.getItem(key);
    }
    return null;
};

export const storeData = (key, data) => {
    if (storageAvailable('localStorage')) {
        localStorage.setItem(key, data);
    }
};

export const removeDataFromStorage = (key) => {
    if (storageAvailable('localStorage')) {
        try {
            localStorage.removeItem(key);
        }catch (e) {
            console.log(e);
        }
    }
};



// WEBPACK FOOTER //
// ./src/Helpers.js